import fetchFileFromUrl from "@/components/Form/utils/file/fetchFileFromUrl";
import createFileData from "@/components/Form/utils/file/createFileData";
import { values } from 'lodash'

const mapToLoad = async (data: any) => {
	const preview = await fetchFileFromUrl(data.preview);
	const previewFile = await createFileData({
		file: preview.file,
		fileExtension: preview.fileExtension,
		url: data.preview,
		types: "image/*",
	});

	const fontStyle = await Promise.all(
		(data.fontStyle || []).map(async (style: any) => {
			const fetched = await fetchFileFromUrl(style.url);
			const fontFile = await createFileData({
				file: fetched.file,
				fileExtension: fetched.fileExtension,
				url: style.url,
				types: "font/woff2,font/woff,application/font-woff2,application/octet-stream,.ttf,.otf",
			});

			return {
				...style,
				id: style.style,
				file: fontFile,
			};
		})
	);

	return {
		...data,
		fontStyle,
		language: {value: (data.language || '')},
		preview: previewFile,
		previewStyle: data.previewStyle ?
			{
				value: data.previewStyle,
				data: fontStyle.find((s:any)=> s.id === data.previewStyle)
			} :
			{
				value: fontStyle[0]?.id ,
				data: fontStyle[0]
			},
	};
};

export default mapToLoad;